export class CampaignCategoryParams {
  id?: guid;
  title?: string;
  description?: string;
}
